import React from 'react'
import MoreInfo from '../MoreInfo'
import Carousel from '../Carousel'
import ResultsTable from './ResultsTable'
import PropTypes from 'prop-types'

function Step2({ domains, selectDomain, helperStepTwo, isNewRegistry, contactLink, isJumpstarter }) {
  if (domains && domains.length === 0) return null

  return (
    <div className='wrapper'>
      <div className='step__inner'>
        <div className='step__content'>
          <p className='headline'>Step 2</p>
          <div className='step__title'>
            <h3>{isJumpstarter ? 'Select a domain you’d like' : 'Choose a domain'}</h3>
            <MoreInfo content={helperStepTwo} isJumpstarter={isJumpstarter} ariaLabel='Open choose a domain info panel'/>
          </div>
          {!isJumpstarter &&
            <p className='h6 step__description'>
              Decide which domain best suits your needs and select from the options below.
            </p>
          }
        </div>
        {isJumpstarter ? (
          <ResultsTable
            items={domains}
            selectDomain={selectDomain}
            isNewRegistry={isNewRegistry}
            contactLink={contactLink}
          />
        ) : (
          <div className='step__carousel'>
            <Carousel
              items={domains}
              selectDomain={selectDomain}
              isNewRegistry={isNewRegistry}
              contactLink={contactLink}
            />
          </div>
        )}
      </div>
    </div>
  )
}

Step2.propTypes = {
  domains: PropTypes.array,
  selectDomain: PropTypes.func,
  helperStepTwo: PropTypes.string,
  isNewRegistry: PropTypes.bool,
  contactLink: PropTypes.string,
  isJumpstarter: PropTypes.bool,
}

export default Step2
